import { render, staticRenderFns } from "./JuniorHighSchoolMathCourse.vue?vue&type=template&id=5d4efd31&scoped=true&"
import script from "./JuniorHighSchoolMathCourse.vue?vue&type=script&lang=js&"
export * from "./JuniorHighSchoolMathCourse.vue?vue&type=script&lang=js&"
import style0 from "./JuniorHighSchoolMathCourse.vue?vue&type=style&index=0&id=5d4efd31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4efd31",
  null
  
)

export default component.exports